module.exports = __webpack_public_path__ + "static/img/renTab.92ee83f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/renTab.jpg
// module id = GJut
// module chunks = 4